import { render, staticRenderFns } from "./RegisterSpendType.vue?vue&type=template&id=57039fb3"
import script from "./RegisterSpendType.vue?vue&type=script&lang=js"
export * from "./RegisterSpendType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports